import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

const getDataType = arg => (function(v) {
    return (v).substring(v.indexOf(' ') + 1, v.length - 1);
})(Object.prototype.toString.call(arg));

const serviceFormatter = services => {
    let servicesList = {};

    services.map((_services) => { 
        switch(getDataType(_services)) {
            case 'Module':
            case 'Object':
                for(let p in _services) servicesList[p] = _services[p];
                break;

            case 'Array':
                let source = _services[0];
                for(let i=1; i < _services.length; i++) {
                    let s = _services[i];
                    servicesList[s] = source[s];
                }
                break;
        }
    });

    return servicesList;
}

export default function Container(_connect, _class) {
    let { services } = _connect;

    if(_connect.state == null) _connect.state = state => ({ state });

    services = serviceFormatter(services) || [];
    _connect.withRouter = !!_connect.withRouter;

    if(_connect.withRouter) {
        return withRouter(connect(
            state => _connect.state(state),
            dispatch => ({ services: bindActionCreators(
                Object.assign({}, services),
                dispatch
            )})
        )(_class));
    } else {
        return connect(
            state => _connect.state(state),
            dispatch => ({ services: bindActionCreators(
                Object.assign({}, services),
                dispatch
            )})
        )(_class)
    }
}
